import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  FETCH_META_INFO
} from "./actionTypes"
import {
  fetchMetaInfoSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* fetchMetaInfo() {
  try {
    
    const response = yield call(
      makeAjax,
      url.USER_API.listPageMetaInfo,
      {},
      USER_MS_EXT
    );
    if (response.status == 'SUCCESS') {
      yield all([
        put(fetchMetaInfoSuccess({ response: response.data }))
      ]);
    }
    else {
      showMessage(response);
    }
  } catch (error) {
    showMessage(error);
    
    // alert
  }
}

function* metaInfomationSaga() {
  yield takeEvery(FETCH_META_INFO, fetchMetaInfo);
}

export default metaInfomationSaga;
